import { z } from 'zod';
import { CoordinatesSchema } from './geo';
export const AddressSchema = z.object({
    country: z.string(),
    city: z.string(),
    street: z.string(),
    state: z.string().optional(),
    house_number: z.string().optional(),
    zip: z.string().optional(),
    zipcode: z.string().optional(),
    coordinates: CoordinatesSchema.optional(),
});
export const RequiredZipAddressSchema = AddressSchema.omit({ zipcode: true }).extend({
    zip: z.string(),
});
